import notification from '../components/notification';

const ERROR_CODE_ALIASES = {
  ACO002: 'AC0002',
  ACO010: 'AC0010',
  ACO011: 'AC0011',
  ACO015: 'AC0015',
  ACO016: 'AC0016',
  ACO019: 'AC0019',
};

const normalizeErrorCode = (code) => ERROR_CODE_ALIASES[code] || code;

// Helper function to get error message from codes
function getErrorMessageFromCodes(errorCodes, prefix, intl) {
  return errorCodes
    .map((code) => {
      if (code) {
        const messageId = `${prefix}error.${code}`;
        if (intl.messages[messageId]) {
          return intl.formatMessage({ id: messageId });
        }
      }
      return null;
    })
    .find(Boolean);
}

export function apiErrorHandler(err, intl, prefix = '') {
  try {
    // Check if error has response and data
    if (!err?.response?.data) {
      const errorMessage = err?.message || intl.formatMessage({ id: 'error.networkError' }) || 'Network error occurred';
      notification(
        'error',
        intl.formatMessage({ id: 'common.error' }),
        errorMessage,
      );
      return;
    }

    const errorData = err.response.data;
    
    // Handle specific error codes
    if (errorData.code === 'E999') {
      notification('error', intl.formatMessage({ id: 'freezeAccountError' }));
      return;
    }
    
    if (errorData.code === 'E998') {
      notification('error', intl.formatMessage({ id: 'terminatedAccountError' }));
      return;
    }

    if (errorData.code === 'U0007') {
      notification('error', intl.formatMessage({ id: 'common.submit.error.U0007' }));
      return;
    }

    if (errorData.code === 'SPBR0002') {
      notification('error', intl.formatMessage({ id: 'common.submit.error.SPBR0002' }));
      return;
    }
    if (errorData.code === 'ST0007') {
      notification('error', intl.formatMessage({ id: 'common.error' }), errorData.detail);
      return;
    }
    if (errorData.code === 'ST0004') {
      notification('error', intl.formatMessage({ id: 'common.error' }), errorData.detail);
      return;
    }

    // Try to find localized error messageU0007
    const errorCodes = [
      errorData.code,
      errorData.returnCode,
      errorData.errorCode,
    ].filter(Boolean).map(normalizeErrorCode);
    
    const errorCodeTitle = getErrorMessageFromCodes(errorCodes, prefix, intl);
    const errorDescription = errorData.detail || errorData.message || '';

    
    if (errorCodeTitle || errorDescription) {
      notification(
        'error',
        intl.formatMessage({ id: 'common.error' }),
        errorCodeTitle || errorDescription,
      );
    } else {
      // Fallback to generic error message
      const errorCode = errorCodes[0] || 'UNKNOWN';
      notification(
        'error',
        intl.formatMessage({ id: 'common.error' }),
        `${intl.formatMessage({ id: 'error.unknownError' })} Error Code: ${errorCode}`,
      );
    }
  } catch (e) {
    notification(
      'error',
      intl.formatMessage({ id: 'common.error' }),
      intl.formatMessage({ id: 'error.unknownError' }) || 'An unknown error occurred',
    );
  }
}
